import { pipe } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  selectAppConfigValueByKey,
  selectStartPageUrl,
} from './app-config.selectors';

export const selectOnboardingBaseUrl = selectAppConfigValueByKey(
  'onboardingAccountFacade',
);
export const selectOnboardingClientId =
  selectAppConfigValueByKey('onboardingClientId');
export const selectOnboardingClientSecret = selectAppConfigValueByKey(
  'onboardingClientSecret',
);
export const selectOnboardingSecondLevelUrl = selectStartPageUrl;
export const selectOnboardingInterestWizardCancelUrl = selectStartPageUrl;
export const selectOnboardingInterestWizardDonelUrl = pipe(
  selectStartPageUrl,
  map((url) => `${url}?verify-login=1`),
);
